// Translations for EN, ES, FR
export const translations = {
  en: {
    nav: { home: 'HOME', games: 'GAMES', presale: 'PRESALE', staking: 'STAKING', tokenomics: 'TOKENOMICS', roadmap: 'ROADMAP', whitepaper: 'WHITEPAPER', faq: 'FAQ' },
    hero: {
      tagline: 'THE #1 1V1 GAME PLATFORM ON SOLANA',
      title1: 'PLAY. WIN.',
      title2: 'BECOME A',
      title3: 'LEGEND',
      description: 'Domino Arena is a next-generation social gaming and decentralized finance ecosystem designed to combine competitive classic board games with decentralized finance. Our mission is to create a sustainable, transparent and captivating platform where players can compete, bet and win safely.',
      blockchain: 'BLOCKCHAIN', secure: 'SECURE',
      playToEarn: 'PLAY TO EARN', realRewards: 'REAL REWARDS',
      fairPlay: 'FAIR PLAY', audited: '100% AUDITED',
      joinPresale: 'JOIN PRESALE', whitepaper: 'WHITEPAPER',
    },
    presale: {
      live: 'PRESALE IS LIVE', phase: 'PHASE 2', raised: 'USDT RAISED', softCap: 'SOFT CAP',
      amount: 'AMOUNT TO DEPOSIT', minDeposit: 'MINIMUM DEPOSIT', receive: 'YOU WILL RECEIVE',
      depositNow: 'DEPOSIT NOW', payment: 'PAYMENT METHODS',
      listing: 'LISTING PRICE', completed: 'COMPLETED', upcoming: 'UPCOMING', comingSoon: 'COMING SOON',
    },
    games: { title: 'OUR GAMES', playNow: 'PLAY NOW', comingSoon: 'COMING SOON' },
    cube: { title: 'CUBE EVOLUTION', new: 'NEW', desc: 'Deposit your DOMIA in the Cube and participate in future exclusive tournaments organized by the Domino Arena ecosystem.', button: 'DEPOSIT IN THE CUBE' },
    why: {
      title: 'WHY DOMINO ARENA ?',
      p1: 'Gaming platform built on Solana',
      p2: 'Play to Earn – Win real rewards',
      p3: 'Daily tournaments, rankings & events',
      p4: 'Real rewards with DOMIA tokens',
      p5: 'Multi-games on a single platform',
      p6: 'Secure, transparent and 100% audited',
      d1: 'Benefit from the power of the Solana blockchain for instant transactions and nearly non-existent network fees.',
      d2: 'Every victory in your favorite games (Domino, Ludo, etc.) is rewarded with DOMIA tokens, which you can withdraw or reinvest.',
      d3: 'Participate in regular competitions and climb the rankings to win additional prizes and exclusive access.',
      d4: 'The DOMIA token is not just a score: it has real value. Convert it to USDT, use it for shop purchases or bet it in the game.',
      d5: 'A single account gives you access to an entire ecosystem: Domino, Ludo, Chess, Tic-Tac-Toe, Funbets and sports betting, and a bit more.',
      d6: 'Security is our priority. Our smart contracts are audited by third-party firms and all transactions are traceable on the blockchain.',
    },
    details: { title: 'PRESALE DETAILS', supply: 'Total Supply', softCap: 'Soft Cap', hardCap: 'Hard Cap', phases: 'Total Phases', listing: 'Listing Price', blockchain: 'Blockchain' },
    community: { title: 'JOIN THE COMMUNITY', follow: 'Follow us', join: 'Join Channel', subscribe: 'Subscribe' },
    partners: 'OUR PARTNERS', sponsors: 'SPONSORS – COMING',
    loginGate: {
      tagline: 'EXCLUSIVE EARLY ACCESS',
      description: 'Sign in or create an account with your Gmail to access the presale, dashboard and DOMIA rewards.',
      motivation: 'Secure your position in the Domino Arena ecosystem. Participate in the presale, build your portfolio with DOMIA tokens, and unlock a 1,000 DOMIA Airdrop reward.',
      signIn: 'Sign In',
      createAccount: 'Create Account',
      readWhitepaper: 'Read Whitepaper',
      orFollow: 'Follow us on social media',
      secure: 'Secure', pte: 'Play to Earn', audited: 'Audited',
      title1: 'PLAY. WIN.', title2: 'BECOME A', title3: 'LEGEND',
      subtitle: 'The #1 Game Platform on',
      continueWithGoogle: 'Continue with Google',
      orContinueEmail: 'OR CONTINUE WITH EMAIL',
      emailPlaceholder: 'Email address',
      passwordPlaceholder: 'Password',
      rememberMe: 'Remember me',
      forgotPassword: 'Forgot password?',
      presaleStartsIn: 'PRESALE STARTS IN',
      days: 'DAYS', hours: 'HOURS', minutes: 'MINUTES', seconds: 'SECONDS',
      presaleStartsOn: 'Presale starts on July 1, 2026 at 04:00 (UTC)',
      startPrice: 'START PRICE',
      airdropTitle: 'AIRDROP',
      airdropDesc: 'Secure your place in the Domino Arena ecosystem. Join the presale, grow your portfolio with DOMIA tokens and receive a reward of 1,000 DOMIA via airdrop 🎁🎁.',
      securityDesc: 'Advanced and secured blockchain technology',
      pteDesc: 'Play, compete and earn exclusive DOMIA rewards',
      auditedDesc: '100% transparent and audited smart contract',
      followSocial: 'FOLLOW US ON SOCIAL MEDIA',
      footerCopy: '© 2026 Domino Arena. All rights reserved.',
      terms: 'Terms & Conditions', privacy: 'Privacy Policy', disclaimer: 'Disclaimer', contact: 'Contact Us',
    },
    captcha: {
      required: 'Please complete the security check before continuing.',
      verifying: 'Verifying...',
    },
    auth: {
      signInTitle: 'Sign In', registerTitle: 'Create Account', verifyTitle: 'Verify Email',
      emailLabel: 'EMAIL', usernameLabel: 'USERNAME', passwordLabel: 'PASSWORD', codeLabel: 'VERIFICATION CODE',
      submitLogin: 'Sign In', submitRegister: 'Create Account', submitVerify: 'Verify',
      resendCode: 'Resend code',
      noAccount: "Don't have an account?", hasAccount: 'Already have an account?',
      register: 'Register', login: 'Login',
    },
    dashboard: {
      verified: 'Verified account', balance: 'DOMIA Balance', toggle: 'Show / Hide',
      deposit: 'Deposit DOMIA', withdraw: 'Withdraw DOMIA',
      affiliate: 'Affiliate revenue', withdrawBtn: 'Withdraw',
      airdrops: 'Wallet Airdrops', profile: 'Profile', notifications: 'Notifications',
      security: 'Security', referral: 'Referral program', playerId: 'Player ID', logout: 'Log out',
    },
  },
  fr: {
    nav: { home: 'ACCUEIL', games: 'JEUX', presale: 'PRÉVENTE', staking: 'STAKING', tokenomics: 'TOKENOMICS', roadmap: 'FEUILLE DE ROUTE', whitepaper: 'LIVRE BLANC', faq: 'FAQ' },
    hero: {
      tagline: 'LA PLATEFORME DE JEU 1V1 N°1 SUR SOLANA',
      title1: 'JOUEZ. GAGNEZ.',
      title2: 'DEVENEZ UNE',
      title3: 'LÉGENDE',
      description: 'Domino Arena est un écosystème de jeux sociaux et de finance décentralisée de nouvelle génération conçu pour allier jeux de société classiques compétitifs et finance décentralisée. Notre mission est de créer une plateforme durable, transparente et captivante où les joueurs peuvent s\'affronter, parier et gagner en toute sécurité.',
      blockchain: 'BLOCKCHAIN', secure: 'SÉCURISÉ',
      playToEarn: 'JOUEZ POUR GAGNER', realRewards: 'VRAIES RÉCOMPENSES',
      fairPlay: 'JEU ÉQUITABLE', audited: '100% AUDITÉ',
      joinPresale: 'REJOINDRE LA PRÉVENTE', whitepaper: 'LIVRE BLANC',
    },
    presale: {
      live: 'LA PRÉVENTE EST EN COURS', phase: 'PHASE 2', raised: 'USDT COLLECTÉS', softCap: 'SOFT CAP',
      amount: 'MONTANT À DÉPOSER', minDeposit: 'DÉPÔT MINIMUM', receive: 'VOUS RECEVREZ',
      depositNow: 'DÉPOSER MAINTENANT', payment: 'MÉTHODES DE PAIEMENT',
      listing: 'PRIX DE COTATION', completed: 'TERMINÉ', upcoming: 'À VENIR', comingSoon: 'BIENTÔT',
    },
    games: { title: 'NOS JEUX', playNow: 'JOUER', comingSoon: 'BIENTÔT' },
    cube: { title: 'CUBE ÉVOLUTION', new: 'NOUVEAU', desc: 'Déposez vos DOMIA dans le Cube et participez aux futurs tournois exclusifs organisés par l\'écosystème Domino Arena.', button: 'DÉPOSER DANS LE CUBE' },
    why: {
      title: 'POURQUOI DOMINO ARENA ?',
      p1: 'Plateforme de jeux construite sur Solana',
      p2: 'Play to Earn – Gagnez de vraies récompenses',
      p3: 'Tournois quotidiens, classements & événements',
      p4: 'Récompenses réelles avec les tokens DOMIA',
      p5: 'Multi-jeux en 1 seule plateforme',
      p6: 'Sécurisé, transparent et 100% audité',
      d1: 'Bénéficiez de la puissance de la blockchain Solana pour des transactions instantanées et des frais de réseau presque inexistants.',
      d2: 'Chaque victoire dans vos jeux préférés (Domino, Ludo, etc.) est récompensée en jetons DOMIA, que vous pouvez retirer ou réinvestir.',
      d3: 'Participez à des compétitions régulières et grimpez dans le classement pour gagner des prix supplémentaires et des accès exclusifs.',
      d4: 'Le jeton DOMIA n\'est pas juste un score : il a une valeur réelle. Convertissez-le en USDT, utilisez-le pour des achats dans la boutique ou misez-le dans le jeu.',
      d5: 'Un compte unique vous donne accès à tout un écosystème : Domino, Ludo, Échecs, Tic-Tac-Toe, Funbets et paris sportifs et un peu plus encore.',
      d6: 'La sécurité est notre priorité. Nos contrats intelligents sont audités par des firmes tierces et toutes les transactions sont traçables sur la blockchain.',
    },
    details: { title: 'DÉTAILS DE LA PRÉVENTE', supply: 'Offre totale', softCap: 'Soft Cap', hardCap: 'Hard Cap', phases: 'Phases totales', listing: 'Prix de cotation', blockchain: 'Blockchain' },
    community: { title: 'REJOINDRE LA COMMUNAUTÉ', follow: 'Suivez-nous', join: 'Rejoindre', subscribe: 'S\'abonner' },
    partners: 'NOS PARTENAIRES', sponsors: 'SPONSORS – À VENIR',
    loginGate: {
      tagline: 'ACCÈS ANTICIPÉ EXCLUSIF',
      description: 'Connectez-vous ou créez un compte avec votre Gmail pour accéder à la prévente, au dashboard et aux récompenses DOMIA.',
      motivation: 'Sécurisez votre position dans l\'écosystème Domino Arena. Participez à la prévente, construisez votre portefeuille en tokens DOMIA et débloquez une récompense Airdrop de 1 000 DOMIA.',
      signIn: 'Connexion',
      createAccount: 'Créer un compte',
      readWhitepaper: 'Lire le Livre Blanc',
      orFollow: 'Suivez-nous sur les réseaux sociaux',
      secure: 'Sécurisé', pte: 'Play to Earn', audited: 'Audité',
      title1: 'JOUEZ. GAGNEZ.', title2: 'DEVENEZ UNE', title3: 'LÉGENDE',
      subtitle: 'La plateforme de jeux N°1 sur',
      continueWithGoogle: 'Continuer avec Google',
      orContinueEmail: 'OU CONTINUER AVEC EMAIL',
      emailPlaceholder: 'Adresse email',
      passwordPlaceholder: 'Mot de passe',
      rememberMe: 'Se souvenir de moi',
      forgotPassword: 'Mot de passe oublié ?',
      presaleStartsIn: 'LA PRÉVENTE COMMENCE DANS',
      days: 'JOURS', hours: 'HEURES', minutes: 'MINUTES', seconds: 'SECONDES',
      presaleStartsOn: 'La prévente commence le 1er juillet 2026 à 04:00 (UTC)',
      startPrice: 'PRIX DE DÉPART',
      airdropTitle: 'AIRDROP',
      airdropDesc: 'Sécurisez votre place dans l\'écosystème Domino Arena. Rejoignez la prévente, faites grandir votre portefeuille avec les tokens DOMIA et recevez une récompense de 1 000 DOMIA via airdrop 🎁🎁.',
      securityDesc: 'Technologie blockchain avancée et sécurisée',
      pteDesc: 'Jouez, gagnez des récompenses DOMIA exclusives',
      auditedDesc: 'Smart contract 100% transparent et audité',
      followSocial: 'SUIVEZ-NOUS SUR LES RÉSEAUX SOCIAUX',
      footerCopy: '© 2026 Domino Arena. Tous droits réservés.',
      terms: 'Conditions Générales', privacy: 'Politique de Confidentialité', disclaimer: 'Avertissement', contact: 'Nous Contacter',
    },
    captcha: {
      required: 'Veuillez compléter la vérification de sécurité avant de continuer.',
      verifying: 'Vérification...',
    },
    auth: {
      signInTitle: 'Connexion', registerTitle: 'Créer un compte', verifyTitle: 'Vérifier l\'email',
      emailLabel: 'EMAIL', usernameLabel: 'NOM D\'UTILISATEUR', passwordLabel: 'MOT DE PASSE', codeLabel: 'CODE DE VÉRIFICATION',
      submitLogin: 'Connexion', submitRegister: 'Créer le compte', submitVerify: 'Vérifier',
      resendCode: 'Renvoyer le code',
      noAccount: 'Pas encore de compte ?', hasAccount: 'Vous avez déjà un compte ?',
      register: 'S\'inscrire', login: 'Connexion',
    },
    dashboard: {
      verified: 'Compte vérifié', balance: 'Équilibre DOMIA', toggle: 'Afficher / Masquer',
      deposit: 'Dépôt DOMIA', withdraw: 'Retirer DOMIA',
      affiliate: 'Revenus d\'affiliation', withdrawBtn: 'Retirer',
      airdrops: 'Airdrops de portefeuilles', profile: 'Profil', notifications: 'Notifications',
      security: 'Sécurité', referral: 'Programme de parrainage', playerId: 'ID du joueur', logout: 'Déconnecté',
    },
  },
  es: {
    nav: { home: 'INICIO', games: 'JUEGOS', presale: 'PREVENTA', staking: 'STAKING', tokenomics: 'TOKENOMICS', roadmap: 'HOJA DE RUTA', whitepaper: 'WHITEPAPER', faq: 'FAQ' },
    hero: {
      tagline: 'LA PLATAFORMA DE JUEGO 1V1 N°1 EN SOLANA',
      title1: 'JUEGA. GANA.',
      title2: 'CONVIÉRTETE EN UNA',
      title3: 'LEYENDA',
      description: 'Domino Arena es un ecosistema de juegos sociales y finanzas descentralizadas de próxima generación diseñado para combinar juegos de mesa clásicos competitivos con finanzas descentralizadas. Nuestra misión es crear una plataforma sostenible, transparente y cautivadora donde los jugadores puedan competir, apostar y ganar de forma segura.',
      blockchain: 'BLOCKCHAIN', secure: 'SEGURO',
      playToEarn: 'JUEGA PARA GANAR', realRewards: 'RECOMPENSAS REALES',
      fairPlay: 'JUEGO JUSTO', audited: '100% AUDITADO',
      joinPresale: 'UNIRSE A LA PREVENTA', whitepaper: 'WHITEPAPER',
    },
    presale: {
      live: 'PREVENTA EN VIVO', phase: 'FASE 2', raised: 'USDT RECAUDADOS', softCap: 'SOFT CAP',
      amount: 'CANTIDAD A DEPOSITAR', minDeposit: 'DEPÓSITO MÍNIMO', receive: 'RECIBIRÁS',
      depositNow: 'DEPOSITAR AHORA', payment: 'MÉTODOS DE PAGO',
      listing: 'PRECIO DE COTIZACIÓN', completed: 'COMPLETADO', upcoming: 'PRÓXIMO', comingSoon: 'PRÓXIMAMENTE',
    },
    games: { title: 'NUESTROS JUEGOS', playNow: 'JUGAR', comingSoon: 'PRÓXIMAMENTE' },
    cube: { title: 'CUBO EVOLUCIÓN', new: 'NUEVO', desc: 'Deposita tus DOMIA en el Cubo y participa en futuros torneos exclusivos organizados por el ecosistema Domino Arena.', button: 'DEPOSITAR EN EL CUBO' },
    why: {
      title: '¿POR QUÉ DOMINO ARENA?',
      p1: 'Plataforma de juegos construida en Solana',
      p2: 'Play to Earn – Gana recompensas reales',
      p3: 'Torneos diarios, rankings y eventos',
      p4: 'Recompensas reales con tokens DOMIA',
      p5: 'Multi-juegos en una sola plataforma',
      p6: 'Seguro, transparente y 100% auditado',
      d1: 'Aprovecha el poder de la blockchain Solana para transacciones instantáneas y comisiones de red casi inexistentes.',
      d2: 'Cada victoria en tus juegos favoritos (Domino, Ludo, etc.) se recompensa con tokens DOMIA, que puedes retirar o reinvertir.',
      d3: 'Participa en competiciones regulares y sube en la clasificación para ganar premios adicionales y accesos exclusivos.',
      d4: 'El token DOMIA no es solo una puntuación: tiene valor real. Conviértelo en USDT, úsalo para compras en la tienda o apuéstalo en el juego.',
      d5: 'Una sola cuenta te da acceso a todo un ecosistema: Domino, Ludo, Ajedrez, Tic-Tac-Toe, Funbets y apuestas deportivas, y un poco más.',
      d6: 'La seguridad es nuestra prioridad. Nuestros contratos inteligentes son auditados por firmas externas y todas las transacciones son rastreables en la blockchain.',
    },
    details: { title: 'DETALLES DE PREVENTA', supply: 'Suministro total', softCap: 'Soft Cap', hardCap: 'Hard Cap', phases: 'Fases totales', listing: 'Precio de cotización', blockchain: 'Blockchain' },
    community: { title: 'UNIRSE A LA COMUNIDAD', follow: 'Síguenos', join: 'Unirse', subscribe: 'Suscribirse' },
    partners: 'NUESTROS SOCIOS', sponsors: 'PATROCINADORES – PRÓXIMAMENTE',
    loginGate: {
      tagline: 'ACCESO ANTICIPADO EXCLUSIVO',
      description: 'Inicia sesión o crea una cuenta con tu Gmail para acceder a la preventa, panel y recompensas DOMIA.',
      motivation: 'Asegura tu posición en el ecosistema Domino Arena. Participa en la preventa, construye tu portafolio con tokens DOMIA y desbloquea una recompensa Airdrop de 1 000 DOMIA.',
      signIn: 'Iniciar sesión',
      createAccount: 'Crear cuenta',
      readWhitepaper: 'Leer Whitepaper',
      orFollow: 'Síguenos en redes sociales',
      secure: 'Seguro', pte: 'Play to Earn', audited: 'Auditado',
      title1: 'JUEGA. GANA.', title2: 'CONVIÉRTETE EN UNA', title3: 'LEYENDA',
      subtitle: 'La plataforma de juegos N°1 en',
      continueWithGoogle: 'Continuar con Google',
      orContinueEmail: 'O CONTINUAR CON EMAIL',
      emailPlaceholder: 'Correo electrónico',
      passwordPlaceholder: 'Contraseña',
      rememberMe: 'Recuérdame',
      forgotPassword: '¿Olvidaste tu contraseña?',
      presaleStartsIn: 'LA PREVENTA COMIENZA EN',
      days: 'DÍAS', hours: 'HORAS', minutes: 'MINUTOS', seconds: 'SEGUNDOS',
      presaleStartsOn: 'La preventa comienza el 1 de julio de 2026 a las 04:00 (UTC)',
      startPrice: 'PRECIO INICIAL',
      airdropTitle: 'AIRDROP',
      airdropDesc: 'Asegura tu lugar en el ecosistema Domino Arena. Únete a la preventa, haz crecer tu portafolio con tokens DOMIA y recibe una recompensa de 1 000 DOMIA mediante airdrop 🎁🎁.',
      securityDesc: 'Tecnología blockchain avanzada y segura',
      pteDesc: 'Juega y gana recompensas DOMIA exclusivas',
      auditedDesc: 'Smart contract 100% transparente y auditado',
      followSocial: 'SÍGUENOS EN LAS REDES SOCIALES',
      footerCopy: '© 2026 Domino Arena. Todos los derechos reservados.',
      terms: 'Términos y Condiciones', privacy: 'Política de Privacidad', disclaimer: 'Aviso Legal', contact: 'Contáctanos',
    },
    captcha: {
      required: 'Por favor completa la verificación de seguridad antes de continuar.',
      verifying: 'Verificando...',
    },
    auth: {
      signInTitle: 'Iniciar sesión', registerTitle: 'Crear cuenta', verifyTitle: 'Verificar email',
      emailLabel: 'CORREO', usernameLabel: 'NOMBRE DE USUARIO', passwordLabel: 'CONTRASEÑA', codeLabel: 'CÓDIGO DE VERIFICACIÓN',
      submitLogin: 'Iniciar sesión', submitRegister: 'Crear cuenta', submitVerify: 'Verificar',
      resendCode: 'Reenviar código',
      noAccount: '¿No tienes cuenta?', hasAccount: '¿Ya tienes cuenta?',
      register: 'Registrarse', login: 'Iniciar sesión',
    },
    dashboard: {
      verified: 'Cuenta verificada', balance: 'Saldo DOMIA', toggle: 'Mostrar / Ocultar',
      deposit: 'Depositar DOMIA', withdraw: 'Retirar DOMIA',
      affiliate: 'Ingresos de afiliados', withdrawBtn: 'Retirar',
      airdrops: 'Airdrops de billetera', profile: 'Perfil', notifications: 'Notificaciones',
      security: 'Seguridad', referral: 'Programa de referidos', playerId: 'ID del jugador', logout: 'Cerrar sesión',
    },
  },
};
